import { motion, AnimatePresence } from "framer-motion";
import { Heart, Send, MessageCircle, Sparkles } from "lucide-react";

export default function MatchModal({ open, matched, onSendMessage, onKeepSwiping, myFirstName }) {
  return (
    <AnimatePresence>
      {open && matched && (
        <motion.div
          data-testid="match-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-md"
        >
          <motion.div
            initial={{ scale: 0.85, y: 30 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
            className="mx-6 w-full max-w-sm rounded-[32px] overflow-hidden shadow-2xl bg-gradient-to-br from-[#FFF5F0] via-[#FFE0CC] to-[#F4A261] p-6 text-center relative"
          >
            {/* Confetti hearts */}
            {Array.from({ length: 14 }).map((_, i) => {
              const angle = (i / 14) * Math.PI * 2;
              const r = 120 + Math.random() * 80;
              const tx = Math.cos(angle) * r;
              const ty = Math.sin(angle) * r - 40;
              return (
                <motion.div
                  key={i}
                  initial={{ x: 0, y: 0, opacity: 0, scale: 0.4 }}
                  animate={{ x: tx, y: ty, opacity: [0, 1, 0], scale: 1.2 }}
                  transition={{ duration: 1.6, delay: i * 0.04, ease: "easeOut" }}
                  className="absolute left-1/2 top-1/2 pointer-events-none"
                >
                  <Heart className="w-5 h-5 text-white/90" fill="white" strokeWidth={0} />
                </motion.div>
              );
            })}

            <motion.div
              initial={{ scale: 0.5, rotate: -15 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{ type: "spring", delay: 0.2, stiffness: 200 }}
              className="mx-auto w-20 h-20 rounded-full bg-white/60 backdrop-blur flex items-center justify-center mb-4 shadow-lg"
            >
              <Sparkles className="w-9 h-9 text-[color:var(--peach-deep)]" fill="currentColor" strokeWidth={0} />
            </motion.div>

            <h2 className="font-[Onest] font-extrabold text-4xl text-white drop-shadow-md">
              Это взаимно!
            </h2>
            <p className="mt-2 text-white/90 text-sm">
              {myFirstName ? `${myFirstName}, ` : ""}вы понравились {matched?.first_name}
            </p>

            {matched?.photos?.[0]?.data_url && (
              <div className="mt-5 flex items-center justify-center gap-3">
                <img
                  src={matched.photos[0].data_url}
                  alt=""
                  className="w-24 h-24 rounded-3xl object-cover border-4 border-white shadow-md"
                />
              </div>
            )}

            <div className="mt-6 flex flex-col gap-2">
              <button
                data-testid="match-send-message"
                onClick={onSendMessage}
                className="btn-pill bg-white text-[color:var(--peach-deep)] flex items-center justify-center gap-2 font-bold"
              >
                <MessageCircle className="w-4 h-4" />
                Написать сообщение
              </button>
              <button
                data-testid="match-keep-swiping"
                onClick={onKeepSwiping}
                className="btn-pill bg-white/20 text-white border border-white/40"
              >
                Смотреть дальше
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
